<div [hidden]="!isOnline">
  <ng-progress
    class="direction-left-right"
    [debounceTime]="1"
    [trickleSpeed]="300"
    [meteor]="true"
    [spinner]="false"
    [thick]="true"
    [fixed]="true"
    [min]="0.08"
    [max]="100"
    [ease]="'linear'"
    [color]="'#fed028'"
  ></ng-progress>
  <splash-screen *ngIf="loader"></splash-screen>
  <router-outlet></router-outlet>
</div>

<div class="overlay overlay-block" [hidden]="isOnline">
  <div class="row mt-5">
    <h1 class="m-auto">You are Offline !</h1>
  </div>
  <div class="overlay-wrapper">
    <app-custom-error-page
      style="position: absolute; bottom: -183px"
    ></app-custom-error-page>
  </div>
</div>
